module.exports = __webpack_public_path__ + "static/media/loc6_img3.30c1fd7b.jpg";